<template>
  <div class="help-document-container">
    <div class="xps-medusa-document">
      <a href="https://medusa.xsyxsc.com/docsgroup/efficacy/xps/baseOption.html" target="_blank">查看xps文档</a>
    </div>
    <div class="xps-document">
      <h4>系统文档：</h4>
      <div class="link" v-for="(item,index) in documents.xps" :key="index">
        <a :href="item.url" target="_blank">{{item.title}}</a>
      </div>
    </div>
    <div class="yuque-document">
      <h4>语雀文档：</h4>
      <div class="link" v-for="(item,index) in documents.yuque" :key="index">
        <a :href="item.url" target="_blank">{{item.title}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      documents: {}
    }
  },
  mounted () {
    this.initDocument();
  },
  methods: {
    async initDocument () {
      const { data } = await axios.get('https://front-xps-cdn.xsyx.xyz/custom/xps/static/json/helpDocument.json');
      if (data) {
        this.documents = data;
      } else {
        this.$message.error('帮助文档加载失败！');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.help-document-container {
  position: relative;
  display: flex;
  width: 100%;
  .xps-medusa-document {
    position: absolute;
    top: -60px;
    left: 80px;
    a {
      line-height: 16px;
      &:hover {
        color: #409eff;
      }
    }
  }
  .xps-document,
  .yuque-document {
    width: 50%;
    text-align: center;
    .link {
      margin-bottom: 10px;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>